
/**
 * @file Signup main container
 * @author Denny K. Schuldt
 * @copyright Copyright 2017, Datilmedia S.A.
 */

import React, { Component } from 'react';

import FormContainer from './form-container';



/**
 *
 */
export default class Main extends Component {
  render() {
    return (
      <FormContainer {...this.props}/>
    );
  };
};
